import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { t } from '@lingui/core/macro';
import LocationFilterBase from '@duke-hq/filters/components/LocationFilterBase';
import type { LocationItem } from '@duke-hq/filters/types';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';

export default function LocationsFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const { data: sitesData } = trpcAdmin.providers.locations.listSiteLocations.useQuery({
    providerId: filters.provider ?? '',
    filters: { available: true },
  });

  const { data: regionsData } = trpcAdmin.providers.locations.listSiteRegions.useQuery({
    providerId: filters.provider ?? '',
  });

  const locations: LocationItem[] = [
    ...(sitesData?.map((site) => ({
      id: site.id,
      name: site.name,
      state: site.state,
      type: 'site' as const,
    })) ?? []),
    ...(regionsData?.map((region) => ({
      id: region.id,
      name: region.name,
      state: '',
      type: 'region' as const,
    })) ?? []),
  ];

  const { sites = [], regions = [] } = filters;

  const selected = [...sites.map((id) => `site_${id}`), ...regions.map((id) => `region_${id}`)];

  const handleChange = (sites: string[], regions: string[]) => {
    updateFilters({ sites, regions });
  };

  if (locations.length <= 1) {
    return null;
  }

  return (
    <LocationFilterBase
      locations={locations}
      onChange={handleChange}
      value={selected}
      variant="ghost"
      label={t`Location`}
      regionLabel={t`Region`}
      siteLabel={t`Site`}
    />
  );
}
